export default __webpack_public_path__ + "static/media/bg.c57f8340.png";